import React, { useEffect } from 'react';
import { useAppState, useAppDispatch } from '../../../AppContext';

const Step = ({ isActive, nextStep, children }) => {
  const state = useAppState();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isActive && state?.goToNextStepInWizard) {
      dispatch((state) => ({ ...state, goToNextStepInWizard: false }));
      nextStep();
    }
  }, [isActive, state?.goToNextStepInWizard, nextStep, dispatch]);

  if (!isActive) {
    return null;
  }

  return <>{children}</>;
};

export default Step;
